import React from 'react';
import { Route, Switch } from 'react-router';

import MaintenanceDetail from './MaintenanceDetail';
import MaintenanceList from './MaintenanceList/MaintenanceList';

export default function Maintenances() {
  return (
    <Switch>
      <Route path="/maintenances/:id" component={MaintenanceDetail} />
      <Route path="/maintenances" component={MaintenanceList} />
    </Switch>
  );
}
